import { DetailedHTMLProps, forwardRef, HTMLAttributes, useCallback, useImperativeHandle, useRef } from "react";

export interface IComponentePrintProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    titulo?:string;
    carregarHead?:boolean;
    head?:string;
}
export interface IComponentePrintRef {
    imprimir : () => void;
}
const ComponentePrint = forwardRef<IComponentePrintRef, IComponentePrintProps>(function ComponentePrint(
    {
        children,
        titulo,
        carregarHead,
        head : headParam,
        ...rest
    }:IComponentePrintProps,
    ref
) {
    titulo = titulo ?? "Documento";
    carregarHead = carregarHead ?? true;
    const head = carregarHead ? ((headParam === undefined ? document.head.innerHTML : headParam) ?? "") : "";
    const refDiv = useRef<HTMLDivElement|null>(null);

    const print = useCallback(() => {
        const iframe = document.createElement("iframe");
        iframe.width = "100%";
        iframe.height = "100%";
        iframe.style.border = "none";
        iframe.src = "about:blank";
        
        const documentTitlePrev = document.title;
        document.title = titulo ?? "Documento";

        document.body.appendChild(iframe);
        iframe.contentDocument?.open();
        iframe.contentDocument?.write(head + (refDiv.current?.innerHTML ?? ""));
        iframe.contentWindow?.print();
        iframe.contentDocument?.close();
        document.body.removeChild(iframe);

        document.title = documentTitlePrev;
    }, [refDiv, head]);

    useImperativeHandle(ref, () => {
        return {
            imprimir() {
                print();
            }
        };
    }, [print]);

    return <div
        ref={refDiv}
        {...rest}
    >
        {children}
    </div>
});
export default ComponentePrint;